<template>
    <div class="mt-4 w-50 d-flex align-items-center justify-content-start">
        <img :src="ShieldCheckIcon" class="mr-2" />
        <em class="mb-0" style="color: blue">Dokumen medis digital ini sah diterbitkan {{ KlinikInformation.KlinikName }}
            dan diproses komputer
            menggunakan Aplikasi Izidok
        </em>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
    name: 'SuratPenunjangFormBaseDigitalSign',
    computed: {
        ...mapState('SuratPenunjangStore', ['KlinikInformation',]),
        ...mapGetters('SuratPenunjangStore', ['ShieldCheckIcon'])
    }
}
</script>